// src/api.js
import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "/api",
  timeout: 60000,
});

function readTokenFromStorage() {
  let t = localStorage.getItem("token");
  if (t) return String(t).trim();

  try {
    const u = JSON.parse(localStorage.getItem("user") || "null");
    t = u?.token || u?.accessToken;
    if (t) return String(t).trim();
  } catch {}

  return null;
}

function clearAuthStorage() {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  localStorage.removeItem("auth");
  sessionStorage.removeItem("token");
  sessionStorage.removeItem("user");
  sessionStorage.removeItem("auth");
}

let isRedirectingToLogin = false;

api.interceptors.request.use(
  (config) => {
    const token = readTokenFromStorage();

    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const requestUrl = String(error?.config?.url || "");
    const skipAuthRedirect = Boolean(error?.config?.skipAuthRedirect);

    console.error(
      "API Error:",
      status,
      error?.response?.data || error?.message
    );

    if (status === 401 && !skipAuthRedirect) {
      const isAuthPage =
        window.location.pathname === "/login" ||
        window.location.pathname === "/signin";

      const isAuthEndpoint =
        requestUrl.includes("/auth/login") ||
        requestUrl.includes("/login") ||
        requestUrl.includes("/auth/me");

      if (!isAuthEndpoint) {
        clearAuthStorage();

        if (!isRedirectingToLogin && !isAuthPage) {
          isRedirectingToLogin = true;

          const next = encodeURIComponent(
            `${window.location.pathname}${window.location.search || ""}`
          );

          window.location.href = `/login?expired=1&next=${next}`;
        }
      }
    }

    return Promise.reject(error);
  }
);

export default api;